var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 3.5,
    fill: "#3A3939",
    fillOpacity: 0.25,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6796 12.987L14.9596 10.7071C15.3501 10.3166 15.9832 10.3166 16.3738 10.7071L21.6262 15.9596C22.0168 16.3501 22.0168 16.9832 21.6262 17.3738L19.4529 19.5471C19.1824 19.8176 19.1154 20.2308 19.2864 20.5729C21.2642 24.5284 24.4716 27.7358 28.4271 29.7136C28.7692 29.8846 29.1824 29.8176 29.4529 29.5471L31.6262 27.3738C32.0168 26.9832 32.6499 26.9832 33.0404 27.3738L38.2929 32.6262C38.6834 33.0168 38.6834 33.6499 38.2929 34.0404L36.013 36.3204C33.9016 38.4317 30.559 38.6693 28.1703 36.8777L21.6286 31.9714C19.885 30.6638 18.3362 29.115 17.0286 27.3714L12.1223 20.8297C10.3307 18.441 10.5683 15.0984 12.6796 12.987Z",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8d35d705e7bbc31d37158f0c6b559574.svg";
export { ForwardRef as ReactComponent };